import { fromJS } from 'immutable';

export default {
    setRemotes: (state, remotes) => {
        return state.setIn(['list'], fromJS(remotes)).set('initialized', true);
    },
    updateRemotes: (state, remotes) => {
        return state.mergeIn(['list'], fromJS(remotes));
    }
};



// WEBPACK FOOTER //
// ./environments/myfhe/data/Remote/core.js